import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {Loyalty} from "../redux/reducers/loyalty.reducer";
import { ConfigService } from "../../helpers/config.service";

@Injectable({
  providedIn: 'root',
})
export class LoyaltySharedService {

  url = {
    loyalty: (storeCode) => 'rest/' + storeCode + '/V1/amadeus/private/loyalty/config',
  };

  constructor (
    private httpClient: HttpClient,
    private readonly initService: ConfigService
    ) {}

  initLoyaltyConfig(storeCode): Observable<Loyalty> {

    return this.httpClient.get<any>(this.initService.getEnvConfig().AD_MAGENTO_URL + this.url.loyalty(storeCode));

  }

}
